import { useFlags } from "launchdarkly-react-client-sdk";

/**
 * The `cultureReport` LaunchDarkly release flag.
 *
 * Gates every Culture Report surface: the culture insights landing page, the generate and insights
 * views, and the Business profile page that feeds them. Off, the Culture area falls back to the
 * tabbed culture page it showed before the report existed.
 */
export const useCultureReportFlag = (): boolean => {
  const { cultureReport } = useFlags();
  return Boolean(cultureReport);
};
